import React, { useState } from "react";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import api, { getErrorMessage } from "../lib/api";

// One-tap "help me keep my streak" request: emails every follower of the child with a one-tap cheer link.
const StreakRescueButton = ({ child, size = "sm", className = "" }) => {
  const [busy, setBusy] = useState(false);
  if (!child?.ownerId || child.readOnly) return null;
  const ask = async () => {
    setBusy(true);
    try {
      const r = (await api.post(`/children/${child.id}/streak-rescue`)).data;
      if (r.sent) toast.success("Rescue request sent", { description: `${r.recipients.length} grandparent${r.recipients.length === 1 ? "" : "s"}/mentor${r.recipients.length === 1 ? "" : "s"} asked to send ${child.panda.name} a cheer.` });
      else if (r.reason === "cooldown") toast("Already asked recently", { description: `You can ask again 3 days after ${new Date(r.last_sent_at).toLocaleDateString()}.` });
      else if (r.reason === "no_followers") toast("No grandparents or mentors yet", { description: "Invite a follower from the Family dashboard first." });
      else toast.error("Email could not be delivered", { description: r.email_error || "" });
    } catch (e) { toast.error(getErrorMessage(e, "Could not send the request")); } finally { setBusy(false); }
  };
  const cls = size === "sm" ? "text-xs px-3 py-1" : "text-sm px-4 py-1.5";
  return (
    <button type="button" onClick={ask} disabled={busy} className={`btn-pill bg-white border-2 border-[#f7931e] text-[#b45309] hover:bg-[#fff3d6] inline-flex items-center gap-1.5 disabled:opacity-60 ${cls} ${className}`} title="Email the grandparents and mentors who follow this child and ask for a cheer" data-testid={`streak-rescue-${child.id}`}>
      <Megaphone size={14} /> {busy ? "Asking..." : "Ask grandparents for a cheer"}
    </button>
  );
};

export default StreakRescueButton;
